module.exports = __webpack_public_path__ + "static/presenting-3-01d8eff1f2831647dee049ef0fcb5416.jpg";